export type RoomBookingDetailsAudience = 'user' | 'host';

export function roomBookingDetailsPath(
  audience: RoomBookingDetailsAudience,
  bookingId: string,
): string {
  return audience === 'host'
    ? `/host/requests/${bookingId}`
    : `/user/bookings/${bookingId}`;
}

export function isHostRoomBookingDetailsPath(pathname: string): boolean {
  return pathname.startsWith('/host/requests/') && pathname !== '/host/requests';
}
